import { relations, sql } from 'drizzle-orm'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'

import { user } from '../../auth'
import { BookFormat, BookLevel, BookTheme, Contributor, Curriculum, Grade, SkillWeight, Subject } from '../../content'

export const UnifiedSearch = pgTable(
  'unified_search',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    userId: text().references(() => user.id, { onDelete: 'cascade' }),
    searchTerm: text(),
    age: integer().array(),
    bookThemeId: uuid().references(() => BookTheme.id, { onDelete: 'set null' }),
    bookLevelId: uuid().references(() => BookLevel.id, { onDelete: 'set null' }),
    bookFormatId: uuid().references(() => BookFormat.id, { onDelete: 'set null' }),
    curriculumId: uuid().references(() => Curriculum.id, { onDelete: 'set null' }),
    gradeId: uuid().references(() => Grade.id, { onDelete: 'set null' }),
    subjectId: uuid().references(() => Subject.id, { onDelete: 'set null' }),
    skillWeightId: uuid().references(() => SkillWeight.id, { onDelete: 'set null' }),
    contributorId: uuid().references(() => Contributor.id, { onDelete: 'set null' }),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),
  },
  (t) => [index('idx_unified_search_user').on(t.userId)],
)

export const unifiedSearchRelations = relations(UnifiedSearch, ({ one }) => ({
  user: one(user, {
    fields: [UnifiedSearch.userId],
    references: [user.id],
  }),
  bookTheme: one(BookTheme, {
    fields: [UnifiedSearch.bookThemeId],
    references: [BookTheme.id],
  }),
  bookLevel: one(BookLevel, {
    fields: [UnifiedSearch.bookLevelId],
    references: [BookLevel.id],
  }),
  bookFormat: one(BookFormat, {
    fields: [UnifiedSearch.bookFormatId],
    references: [BookFormat.id],
  }),
  curriculum: one(Curriculum, {
    fields: [UnifiedSearch.curriculumId],
    references: [Curriculum.id],
  }),
  grade: one(Grade, {
    fields: [UnifiedSearch.gradeId],
    references: [Grade.id],
  }),
  subject: one(Subject, {
    fields: [UnifiedSearch.subjectId],
    references: [Subject.id],
  }),
  skillWeight: one(SkillWeight, {
    fields: [UnifiedSearch.skillWeightId],
    references: [SkillWeight.id],
  }),
  contributor: one(Contributor, {
    fields: [UnifiedSearch.contributorId],
    references: [Contributor.id],
  }),
}))

export const InsertUnifiedSearchSchema = createInsertSchema(UnifiedSearch).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})
export const SelectUnifiedSearchSchema = createSelectSchema(UnifiedSearch)

export type InsertUnifiedSearch = typeof UnifiedSearch.$inferInsert
export type SelectUnifiedSearch = typeof UnifiedSearch.$inferSelect
